import { treaty } from "@elysiajs/eden";
import type { TreatyClient } from "@frontend-common/api-client-provider";
import { getCurrentLanguage } from "@/hooks/use-language";
import { getShopFromLocalStorage } from "@/hooks/use-shop";
import { getServerUrl } from "./runtime-config";

export function getApiClient({
  locale,
  countryCode,
  kioskKey,
  serverUrl,
  token,
}: {
  locale: string;
  countryCode: string;
  kioskKey: string;
  serverUrl: string;
  token?: string | null;
}) {
  return treaty(serverUrl, {
    headers: {
      "lang-key": locale,
      "country-code": countryCode,
      "kiosk-key": kioskKey,
      "operating-system": "kiosk",
      ...(token
        ? {
            Authorization: `Bearer ${token}`,
          }
        : {}),
    },
  }) as unknown as TreatyClient;
}

export function getBackendClient(): TreatyClient {
  const shop = getShopFromLocalStorage();
  const locale = getCurrentLanguage();
  const countryCode = shop?.currencyCode === "EUR" ? "sk" : "hu";
  return treaty(getServerUrl(), {
    headers: {
      "lang-key": locale,
      "country-code": countryCode,
      "kiosk-key": shop?.kioskKey ?? "",
      "operating-system": "kiosk",
    },
  }) as unknown as TreatyClient;
}
